"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBinder = exports.getBinderId = exports.getBinderConfig = exports.isStaticPDFGeneration = exports.masterPolicyPDFStaticGeneration = exports.eActiveBinder = void 0;
const config_1 = require("./config");
const countries_1 = require("../countries");
const binder_class_1 = __importDefault(require("./binder.class"));
var eActiveBinder;
(function (eActiveBinder) {
    eActiveBinder["CAN"] = "tokiomarine_can2024";
    eActiveBinder["USA"] = "tokiomarine2024_2";
    eActiveBinder["EUROPE"] = "tokiomarine_europe_2025";
})(eActiveBinder = exports.eActiveBinder || (exports.eActiveBinder = {}));
exports.masterPolicyPDFStaticGeneration = {
    USA: ["tokiomarine2023", "tokiomarine", "argo"],
    CAN: ["tokiomarine_can2024", "tokiomarine_can2023", "tokiomarine_can"],
    EUROPE: []
};
const isStaticPDFGeneration = (binderId) => exports.masterPolicyPDFStaticGeneration.USA.includes(binderId) ||
    exports.masterPolicyPDFStaticGeneration.CAN.includes(binderId) ||
    exports.masterPolicyPDFStaticGeneration.EUROPE.includes(binderId);
exports.isStaticPDFGeneration = isStaticPDFGeneration;
const getBinderConfig = (binderId, configBinder) => {
    let binderConfig;
    const defaultBinder = configBinder !== null && configBinder !== void 0 ? configBinder : eActiveBinder.USA;
    if (!binderId) {
        binderConfig = config_1.binderConfigs.find((aBinderConfig) => aBinderConfig.id === defaultBinder);
        if (!binderConfig) {
            throw new Error(`Default Binder ${defaultBinder} not found`);
        }
    }
    else {
        binderConfig = config_1.binderConfigs.find((aBinderConfig) => aBinderConfig.id === binderId);
        if (!binderConfig) {
            throw new Error(`Binder ${binderId} not found`);
        }
    }
    return binderConfig;
};
exports.getBinderConfig = getBinderConfig;
const getBinderId = (partner) => __awaiter(void 0, void 0, void 0, function* () {
    if (!partner.address.country) {
        throw new Error(`Error in partner configuration ${partner.id}`);
    }
    if (partner.address.country === "CAN") {
        return eActiveBinder.CAN;
    }
    if (countries_1.isEuropeanCountry(partner.address.country)) {
        return eActiveBinder.EUROPE;
    }
    return eActiveBinder.USA;
});
exports.getBinderId = getBinderId;
const getBinder = (binderId) => {
    const binderConfig = exports.getBinderConfig(binderId);
    return binder_class_1.default.fromObj(binderConfig);
};
exports.getBinder = getBinder;
//# sourceMappingURL=utils.js.map